import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FilterDetails {
  public marketAttribute: string;
  public displayText: string;
}
